import { LocalEnvironment as ImportedLocalEnvironment } from "@packages/config";
import type { Config } from "../config.contract";

export class LocalEnvironment
  extends ImportedLocalEnvironment
  implements Config
{
  /**
   * Enable headers so authorization is sent to the API
   */
  disabledHeaders = false;

  // Favorites usa a mesma propriedade Adobe Launch da garagem (dd5a99595f9f),
  // distinta da propriedade padrão do next.ui (home/search).
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/dd5a99595f9f/launch-f4e34f64effa-development.min.js";
}
